import type { StyleSpecification } from 'maplibre-gl';

/** Подложка Яндекс Карт для отображения сохранённых координат */
export const yandexMapStyle: StyleSpecification = {
    version: 8,
    sources: {
        'yandex-tiles-source': {
            type: 'raster',
            tiles: [`https://core-renderer-tiles.maps.yandex.net/tiles?l=map&x={x}&y={y}&z={z}&lang=ru_RU&projection=web_mercator&scheme=xyz&size=512&scale=2&apikey=${import.meta.env.VITE_YANDEX_API_KEY}`],
            tileSize: 512,
            attribution: '© Яндекс.Карты',
            minzoom: 0,
            maxzoom: 19,
        },
    },
    layers: [{
        id: 'yandex-tiles-layer',
        type: 'raster',
        source: 'yandex-tiles-source',
        minzoom: 0,
        maxzoom: 19,
        paint: {
            'raster-resampling': 'linear',
            'raster-fade-duration': 0
        },
    }],
};
